import React, { useCallback, useContext, useState } from "react";
import {
  ListItem,
  ListItemText,
  TextField,
  makeStyles,
  createStyles,
  Typography,
} from "@material-ui/core";
import NumberFormat from "react-number-format";
import { SubheaderContext } from "../pages/Input";

// CSSスタイルを定義
const useStyles = makeStyles((theme) =>
  createStyles({
    textField: {
      width: "100%",
    },
    multiline: {
      fontSize: 22,
      lineHeight: 1.3,
    },
    number: {
      fontSize: 26,
    },
  })
);

const NumberFormatCustom = React.memo((props) => {
  const { name, inputRef, onChange, ...other } = props;
  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={(values) => {
        onChange({
          target: {
            name: name,
            value: values.value,
          },
        });
      }}
      isNumericString
      inputMode="decimal"
    />
  );
});

const TextFieldCustom = React.memo(({ type, unit, maxLength, ...other }) => {
  const classes = useStyles();

  const { setIsFocusTextarea } = useContext(SubheaderContext);

  const handleFocus = useCallback(() => {
    setIsFocusTextarea(true);
  }, [setIsFocusTextarea]);

  const handleBlur = useCallback(() => {
    setIsFocusTextarea(false);
  }, [setIsFocusTextarea]);

  switch (type) {
    case "textarea":
      return (
        <TextField
          {...other}
          multiline
          rowsMax={99}
          rows={5}
          InputProps={{
            classes: {
              input: classes.multiline,
            },
          }}
          onFocus={handleFocus}
          onBlur={handleBlur}
        />
      );
    case "number":
      return (
        <TextField
          {...other}
          InputProps={{
            endAdornment: <Typography color="textSecondary">{unit}</Typography>,
            inputComponent: NumberFormatCustom,
            classes: {
              input: classes.number,
            },
          }}
          inputProps={{ maxLength: maxLength }}
        />
      );
    default:
      return <TextField {...other} type={type} />;
  }
});

const TextItem = React.memo((props) => {
  const {
    item,
    defaultValue = "",
    onChange,
    rootIdx,
    childIdx,
    grandChildIdx,
  } = props;
  const classes = useStyles();
  const [errorText, setErrorText] = useState("");
  const NUM_MAX_LENGTH = 10;
  const [maxLength, setMaxLength] = useState(NUM_MAX_LENGTH);

  const validateText = useCallback(
    (value) => {
      const max = item.max ? parseFloat(item.max) : "";
      const unit = item.unit ?? "";

      if (max && value > max) {
        setErrorText(`${max}${unit}を超えています`);
        setMaxLength(value.length);
      } else {
        setErrorText("");
        setMaxLength(NUM_MAX_LENGTH);
      }
    },
    [NUM_MAX_LENGTH, item.max, item.unit]
  );

  const handleChangeText = useCallback(
    (e) => {
      if (item.type === "number") {
        validateText(e.target.value);
      }

      onChange(rootIdx, childIdx, grandChildIdx, e.target.value);
    },
    [rootIdx, childIdx, grandChildIdx, onChange, item.type, validateText]
  );

  return (
    <ListItem dense>
      <ListItemText>
        <TextFieldCustom
          variant="outlined"
          type={item.type}
          label={item.name}
          unit={item.unit}
          defaultValue={defaultValue}
          onChange={handleChangeText}
          className={classes.textField}
          error={!!errorText}
          helperText={errorText}
          maxLength={maxLength}
        />
      </ListItemText>
    </ListItem>
  );
});

export default TextItem;
